document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.getElementById('load-more');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
            const button = this;
            const page = parseInt(button.getAttribute('data-page'), 10) + 1;
            const postsPerPage = button.getAttribute('data-posts-per-page');
            const postType = button.getAttribute('data-post-type');
            const lang = button.getAttribute('data-lang');
            const excerptMaxChars = button.getAttribute('data-excerpt-max-chars');
            const container = document.querySelector('.af-post-type-block .row');

            button.setAttribute('disabled', 'disabled');
            button.textContent = 'Loading...';

            wp.apiFetch({ path: `/wp/v2/${postType}?per_page=${postsPerPage}&page=${page}&lang=${lang}&orderby=date&order=asc`})
                .then((newItems) => {
                    if (newItems.length < postsPerPage) {
                        button.style.display = 'none';
                    } else {
                        button.removeAttribute('disabled');
                        button.textContent = 'Load more';
                        button.setAttribute('data-page', page);
                    }

                    newItems.forEach((item) => {
						console.log('new item', item);
                        const itemElement = document.createElement('div');
                        itemElement.className = 'af-post-type-block-item col-12 col-md-6 col-lg-4';
                        itemElement.innerHTML = `
                            <a class="af-post-type-block-image-link" href="${item.link}">
                                ${item.featured_media ? `<img src="${item.featured_media_src_url}" alt="${item.title.rendered}">` : ''}
                            </a>
                            <header class="af-post-type-block-header">
                                <h4><a class="af-post-type-block-title-link d-flex d-md-block align-items-md-center" href="${item.link}">
                                    <span class="h4 d-inline font-weight-bold m-0">${item.title.rendered}</span>
                                </a></h4>
                            </header>
                            <div>
                                <p class="af-post-type-block-excerpt m-0">${item.excerpt.rendered}</p>
                            </div>
                        `;
                        container.appendChild(itemElement);
                    });
                })
                .catch((error) => {
                    console.error('Error fetching more items:', error);
                    button.removeAttribute('disabled');
                    button.textContent = 'Loadm more';
                });
        });
    }
});
